export const originServerMock = [
  {
    id: 'BACKEND_PRODUCTION',
    URL: 'https://us-central1-dagpacket-plataforma.cloudfunctions.net/dagbackend',
    label: 'Backend producción',
    section: 'service_platform',
    extraDesc: 'production',
    localActive: false,
    deployActive: true
  },
  {
    id: 'BACKEND_SANDBOX',
    URL: 'https://us-central1-dagpacket-plataforma.cloudfunctions.net/dagbackendsandox',
    label: 'Backend sandbox',
    section: 'service_platform',
    extraDesc: 'sandbox',
    localActive: true,
    deployActive: false
  },
  {
    id: 'BACKEND_PATITO',
    URL: 'https://us-central1-dagpacket-plataforma.cloudfunctions.net/dagbackendPatito',
    label: 'Backend patito',
    section: 'service_platform',
    extraDesc: 'patito',
    localActive: false,
    deployActive: false
  },
  {
    id: 'LOCKER_V1',
    URL: 'https://us-central1-dagpacket-plataforma.cloudfunctions.net/dagbackend',
    label: 'Locker back v1',
    section: 'locker',
    extraDesc: 'locker-v1',
    localActive: false,
    deployActive: true
  },
  {
    id: 'LOCKER_V2',
    URL: 'https://dagpacketbe.onrender.com',
    label: 'Locker back v2',
    section: 'locker',
    extraDesc: 'locker-v2',
    localActive: true,
    deployActive: false
  }
];
